class IntersectionObserverHandler {
    constructor(options = { threshold: 0.4 }) {
        this.options = options;
        this.animateElements = [];
        this.observer = null;
        this.init();
    }

    init() {
        this.animateElements = [].slice.call(document.querySelectorAll('.animate'));
        
        // Wait for page transition to complete
        if (document.body.classList.contains('page-transitioning')) {
            document.addEventListener('pageTransitionComplete', () => {
                this.setupObserver();
            });
        } else {
            this.setupObserver();
        }
    }

    setupObserver() {
        if ("IntersectionObserver" in window) {
            this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.options);
            this.observeElements();
        } else {
            // Fallback for browsers that don't support IntersectionObserver
            document.addEventListener("scroll", this.lazyLoadFallback.bind(this));
        }
    }

    handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const animateEl = entry.target;
                animateEl.classList.add('reveal');
                observer.unobserve(animateEl);
            }
        });
    }

    observeElements() {
        this.animateElements.forEach(element => {
            this.observer.observe(element);
        });
    }

    lazyLoadFallback() {
        // Implement fallback behavior here if needed
        console.log('IntersectionObserver not supported');
    }

    destroy() {
        if (this.observer) {
            this.animateElements.forEach(element => {
                this.observer.unobserve(element);
            });
            this.observer = null;
        }
        document.removeEventListener("scroll", this.lazyLoadFallback);
    }
}

export default IntersectionObserverHandler;
